import { useEffect, useState } from 'react';

import { Router } from '@reach/router';
import { useDispatch } from 'react-redux';

import InfoBar from './components/InfoBar/InfoBar';
import LoadingBar from './components/LoadingBar/LoadingBar';
import {
  franchises,
  infoBarTexts,
  setAll,
} from './provider/models/franchisesModel';
import { fetchConsents } from './provider/models/reservationModel';
import { downloadedData } from './store/actions';
import { serviceTypes } from './store/initData/services';
import AgePageWrapper from './store/routeWrappers/AgePageWrapper';
import CityPageWrapper from './store/routeWrappers/CityPageWrapper';
import FormPageSingleWrapper from './store/routeWrappers/FormPageSingleWrapper';
import FormPageWrapper from './store/routeWrappers/FormPageWrapper';
import MapPageWrapper from './store/routeWrappers/MapPageWrapper';
import ServicePageWrapper from './store/routeWrappers/ServicePageWrapper';
import ThankYouPageWrapper from './store/routeWrappers/ThankYouPageWrapper';
import WorkshopFormRedirector from './store/routeWrappers/WorkshopFormRedirector';
import { env } from './utils/env';

export default function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const franchisesApiCall = async () => {
      await setAll();
      dispatch(downloadedData(franchises, 'franchises'));

      const consents = await fetchConsents();
      dispatch(downloadedData(consents, 'consents'));

      setLoading(false);
    };

    franchisesApiCall();
  }, [dispatch]);

  const workshopService = serviceTypes.workshop;

  let content = <LoadingBar wholePage />;
  if (!loading) {
    content = (
      <Router
        style={{ position: 'relative', flexGrow: 1 }}
        basepath={`/${env.PUBLIC_URL}`}
      >
        {/* GLOBAL */}
        <CityPageWrapper path="/" />
        <ServicePageWrapper path="/:cityId/" />
        <WorkshopFormRedirector path="/przekieruj/:slug" />
        <ThankYouPageWrapper path="/thanks" />

        {/* WORKSHOP */}
        <AgePageWrapper
          path={`/:cityId/${workshopService}/:ageId/`}
          serviceId={workshopService}
        />
        <MapPageWrapper
          path={`/:cityId/${workshopService}/:ageId/:robotId/*`}
          serviceId={workshopService}
        />
        <FormPageWrapper
          path={`/:cityId/${workshopService}/:ageId/:robotId/:locationId/:occurrenceId/formularz`}
          serviceId={workshopService}
        />
        {/* Signup for single location */}
        <FormPageSingleWrapper
          path={`/:cityId/${workshopService}/:ageId/:robotId/:locationId/:occurrenceId/formularzMiasto`}
          serviceId={workshopService}
        />
        <FormPageWrapper
          addressInput
          path={`/:cityId/${workshopService}/:ageId/:robotId/zaproponuj`}
          serviceId={workshopService}
        />

        {/* SUMMERPLAY and ACADEMY */}
        <MapPageWrapper path={`/:cityId/:serviceId/*`} hideSuggestButton />
        <FormPageWrapper
          path={`/:cityId/:serviceId/:locationId/:occurrenceId/formularz`}
        />
      </Router>
    );
  }

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexFlow: 'column',
        position: 'relative',
      }}
    >
      <InfoBar texts={infoBarTexts} />
      {content}
    </div>
  );
}
